import { render, staticRenderFns } from "./Crash.vue?vue&type=template&id=d476a76c&scoped=true"
import script from "./Crash.vue?vue&type=script&lang=js"
export * from "./Crash.vue?vue&type=script&lang=js"
import style0 from "./Crash.vue?vue&type=style&index=0&id=d476a76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d476a76c",
  null
  
)

export default component.exports